export default __webpack_public_path__ + "static/media/ArchiveSuccessNotificationIcon.d15af6b2.svg";